module.exports = __webpack_public_path__ + "img/115_thumbnail.eb9f13d3.jpg";